import React from 'react';

import {
  ANALYTICS_EVENTS,
  ANALYTICS_VIEW_FEATURES,
  ANALYTICS_VIEWS
} from 'dpl/constants/analytics';
import { sendAnalyticsEvent } from 'dpl/util/analytics';
import { STANDARDS_PATH } from 'dpl/shared/constants/urls';

const BUTTON_CTA = 'Our standards & screening';

export default function GoodDogStandardSectionButton() {
  function handleClick() {
    sendAnalyticsEvent(ANALYTICS_EVENTS.BUTTON_CLICKED, {
      view: ANALYTICS_VIEWS.HOME,
      view_feature: ANALYTICS_VIEW_FEATURES.TRUST_STRIP,
      button_cta: BUTTON_CTA
    });
  }

  return (
    <a
      className="GoodDogStandardSectionButton db dib-ns ba b--default pv4 ph12 fw-medium font-16 stone-700 br1 bg-white tc"
      href={STANDARDS_PATH}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
    >
      {BUTTON_CTA}
    </a>
  );
}
